<template>
  <v-row dense>
    <v-col cols="12" md="4">
      <span class="subtitle-1" v-text="'Artigos'" />
      <div class="wrapper-select">
        <v-select
          v-model="selected"
          class="my-2"
          :items="itemsSelect"
          dense
          outlined
          hide-details
          @change="store.consultaListadePeriodicos"
        />
      </div>
    </v-col>
    <v-col v-if="items && items.length" cols="12">
      <v-data-table
        :items="items"
        :headers="[{ text: 'Título', value: 'deTituloSubtitulo' }]"
      >
        <template #[`item.deTituloSubtitulo`]="{ item }">
          <span>{{ `${items.indexOf(item) + 1}.` }}</span>
          <a
            @click="
              $router.push({
                path:
                  `/obras/visualiza/` +
                  item.cdObra +
                  `/` +
                  TipoObra.ARTIGO_PERIODICO,
                query: { back: 'true' },
              })
            "
          >
            {{ item.deTituloSubtitulo }}
          </a>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { TipoObra } from '@/constants';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { TextValue } from '@/types/common';
import { ColecaoPeriodicoVolume } from '../../types';

const store = ConsultaObrasStore();
const { obraTempImpressao: obra, listaPeriodicos } = storeToRefs(store);

const items = computed(() =>
  listaPeriodicos.value
    ? listaPeriodicos.value
    : obra.value!.artigoPeriodicoList
);

const itemsSelect = computed(
  () =>
    obra.value?.colecaoPeriodicoVolumeList?.map((item) => ({
      text: getLabel(item) ?? '',
      value: item.cdColecaoPeriodicoVolume,
    })) ?? []
);

const selected = ref<TextValue>();

onMounted(() => {
  if (items.value?.length) {
    selected.value = itemsSelect.value[0];
  }
});

const getLabel = (item: ColecaoPeriodicoVolume) => {
  if (item.deVolume && item.deNumero) {
    return `${item.deVolume}/${item.deNumero}`;
  }

  return item.deVolume ?? item.deNumero;
};
</script>
